// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L_pZ","tabsBox":"styles_tabsBox__3enKW","createButton":"styles_createButton__3T-yC"};